










import Vue from 'vue'
import { range } from 'lodash'
import moment from 'moment'

import { AllCasesQuery } from '@/graphql-schema'
import { NotNull, Unpacked } from '@/utils'
import { MyDate } from '@/store/workflow/types'

type Case = Unpacked<NotNull<AllCasesQuery['cases']>['nodes']>
type Appointment = Unpacked<NotNull<Case['myDates']>['nodes']>

export default Vue.extend({
  computed: {
    appointments(): moment.Moment[] {
      const dates: MyDate[] = this.$store.getters['workflow/myDates']
      return dates.map(d => moment(d.timestamp).locale(this.$i18n.locale))
    },
    days(): moment.Moment[] {
      return range(0, 7).map((days: number) =>
        moment()
          .add(days, 'days')
          .locale(this.$i18n.locale)
      )
    },
  },
  methods: {
    hasAppointment(day: moment.Moment): boolean {
      return this.appointments.some(appointment => {
        return day.isSame(appointment, 'date')
      })
    },
  },
})
